(function () {
  'use strict';
  if (window.__lmmKelvinPreviewBound) return;
  window.__lmmKelvinPreviewBound = true;
  var selector = '[data-lmm-kelvin-preview]';
  var anchors = [2200, 2700, 3000, 4000, 6500];
  var copies = new WeakMap();
  var viewed = false;
  var visibleRoots = new Set();
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.4) visibleRoots.add(entry.target);
      else visibleRoots.delete(entry.target);
    });
    trackVisibleWidget();
  }, { threshold: [0, 0.4] }) : null;

  function trackKelvinEvent(eventName, payload) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return false;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (e) { return false; }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var published = window.Shopify.analytics.publish(eventName, payload);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    } catch (e) {}
    return true;
  }

  function trackVisibleWidget() {
    if (viewed) return;
    visibleRoots.forEach(function (root) {
      if (viewed || !root.isConnected) return;
      viewed = trackKelvinEvent('lmm_kelvin_widget_viewed', {
        article_kelvin: Number(root.getAttribute('data-kpv-article-kelvin')),
        page_path: location.pathname
      });
    });
    if (viewed) {
      if (observer) observer.disconnect();
      visibleRoots.clear();
    }
  }

  function trackUse(root, interactionType) {
    trackKelvinEvent('lmm_kelvin_widget_used', {
      interaction_type: interactionType,
      selected_kelvin: Number(root.getAttribute('data-kpv-current')),
      article_kelvin: Number(root.getAttribute('data-kpv-article-kelvin')),
      page_path: location.pathname
    });
  }

  document.addEventListener('visitorConsentCollected', trackVisibleWidget);
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) trackVisibleWidget();
      });
    } catch (e) {}
  }

  function formatKelvin(value) {
    return value.toLocaleString('de-DE') + ' K';
  }

  function update(root, value) {
    var range = root.querySelector('[data-kpv-range]');
    var copy = copies.get(root);
    if (!range || !copy || !Number.isFinite(value)) return;
    var min = Number(range.min) || 2200;
    var max = Number(range.max) || 6500;
    value = Math.min(max, Math.max(min, Math.round(value)));
    range.value = String(value);
    range.setAttribute('aria-valuetext', formatKelvin(value));
    var nearest = anchors.reduce(function (best, next) {
      return Math.abs(next - value) <= Math.abs(best - value) ? next : best;
    }, anchors[0]);
    var output = root.querySelector('[data-kpv-output]');
    if (output) output.textContent = formatKelvin(value);
    var description = root.querySelector('[data-kpv-description]');
    if (description && copy.previewDescriptions[nearest]) {
      var previewText = copy.previewDescriptions[nearest].replace(/^Vorschau\s+[\d.]+\s*K:/, 'Vorschau ' + formatKelvin(value) + ':');
      var articleKelvin = Number(root.getAttribute('data-kpv-article-kelvin'));
      if (value === articleKelvin) {
        previewText += ' Genau diese Lichtfarbe besitzt dieser Artikel.';
      }
      description.textContent = previewText;
    }
    root.querySelectorAll('[data-kpv-preset]').forEach(function (button) {
      var active = Number(button.getAttribute('data-kpv-preset')) === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-kpv-recommendation]').forEach(function (node) {
      var scene = node.getAttribute('data-kpv-recommendation');
      var text = copy.recommendations[nearest] && copy.recommendations[nearest][scene];
      if (typeof text === 'string') node.textContent = text;
    });
    var warmth = Math.min(1, Math.max(0, (4000 - value) / 1800));
    var coolness = Math.min(1, Math.max(0, (value - 4000) / 2500));
    var neutral = [255, 244, 224];
    var endpoint = value < 4000 ? [255, 166, 72] : [205, 229, 255];
    var intensity = value < 4000 ? warmth : coolness;
    var light = neutral.map(function (channel, index) {
      return Math.round(channel + (endpoint[index] - channel) * intensity);
    });
    root.style.setProperty('--kpv-light-rgb', light.join(', '));
    var tint = value < 4000 ? '255, 152, 61' : '80, 144, 255';
    var opacity = warmth * 0.23 + coolness * 0.18;
    root.style.setProperty('--kpv-tint-rgb', tint);
    root.style.setProperty('--kpv-tint', 'rgb(' + tint + ')');
    root.style.setProperty('--kpv-tint-opacity', opacity.toFixed(4));
    root.style.setProperty('--kpv-filter', value === 4000 ? 'none' : 'sepia(' + (warmth * 0.16).toFixed(4) + ') saturate(' + (1 + warmth * 0.06 - coolness * 0.06).toFixed(4) + ')');
    root.style.setProperty('--kpv-range-progress', ((value - min) / (max - min) * 100).toFixed(2) + '%');
    root.setAttribute('data-kpv-current', String(value));
  }

  function initialize(root) {
    if (copies.has(root)) return true;
    var source = root.querySelector('[data-kpv-copy]');
    var range = root.querySelector('[data-kpv-range]');
    if (!source || !range) return false;
    var copy;
    try {
      copy = JSON.parse(source.textContent);
    } catch (error) {
      return false;
    }
    if (!copy.previewDescriptions || !copy.recommendations) return false;
    copies.set(root, copy);
    update(root, Number(root.getAttribute('data-kpv-article-kelvin')) || 4000);
    if (observer && !viewed) observer.observe(root);
    return true;
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  }

  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!(event.target instanceof Element) || !event.target.matches('[data-kpv-range]')) return;
      var root = event.target.closest(selector);
      var value = Number(event.target.value);
      if (root && initialize(root)) {
        update(root, value);
        if (eventName === 'change' && event.isTrusted) trackUse(root, 'slider');
      }
    });
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('[data-kpv-preset], [data-kpv-reset]');
    if (!button) return;
    var root = button.closest(selector);
    if (!root || !initialize(root)) return;
    var value = button.hasAttribute('data-kpv-reset') ? Number(root.getAttribute('data-kpv-article-kelvin')) || 4000 : Number(button.getAttribute('data-kpv-preset'));
    update(root, value);
    if (event.isTrusted && button.hasAttribute('data-kpv-preset')) trackUse(root, 'preset');
  });
  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }
}());
